const saveData = (key, data) => {
  let value = data;
  if (typeof Storage !== "undefined") {
    if (Array.isArray(data)) {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
  }
};

const getData = (key) => localStorage.getItem(key);

const deleteData = () => localStorage.clear();

export { saveData, getData, deleteData };
